export default function HeroSection() {
  const stats = [
    { value: '12,000+', label: '高清影片', icon: 'ri-film-line' },
    { value: '4K HDR', label: '超清画质', icon: 'ri-4k-line' },
    { value: '极速加载', label: '流畅不卡', icon: 'ri-speed-up-line' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20atmosphere%20with%20warm%20red%20velvet%20curtains%20and%20soft%20golden%20stage%20lighting%2C%20dramatic%20film%20noir%20aesthetic%2C%20rich%20deep%20crimson%20and%20amber%20tones%2C%20elegant%20cinema%20architecture%2C%20atmospheric%20smoke%20and%20light%20beams%2C%20luxurious%20classic%20theater%20interior%20with%20ornate%20details%2C%20warm%20spotlight%20glow%20on%20empty%20stage&width=1920&height=1080&seq=mahua-hero-bg&orientation=landscape"
          alt="麻花影院 - 沉浸式观影体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-accent-300 text-sm font-medium">4K蓝光画质 · 流畅不缓冲</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
              麻花影院
              <br />
              <span className="text-accent-400">超清4K影视殿堂</span>
            </h1>

            <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              麻花影院汇聚海量高清电影资源，以4K超清画质、蓝光原画级观影体验为核心，
              每日更新最新院线大片与经典佳作。无论动作巨制、温情剧情还是科幻冒险，
              都能在这里找到极致清晰的观影享受，加载流畅不缓冲，让每一帧画面都如临其境。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                    <i className={`${stat.icon} text-accent-400 text-sm`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-white font-heading font-bold text-lg">{stat.value}</div>
                    <div className="text-white/55 text-xs">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-7 py-3.5 rounded-lg transition-all duration-200 text-sm whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/20 font-medium px-7 py-3.5 rounded-lg transition-all duration-200 text-sm whitespace-nowrap"
              >
                <i className="ri-grid-line text-lg"></i>
                探索专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20poster%20collage%20with%20warm%20golden%20and%20crimson%20lighting%2C%20elegant%20movie%20themed%20composition%20with%20vintage%20film%20strip%20elements%2C%20dramatic%20spotlight%20effect%2C%20classic%20cinema%20aesthetic%2C%20rich%20textures%20of%20velvet%20and%20gold%2C%20film%20projector%20light%20beam%2C%20dark%20atmospheric%20background%20with%20warm%20highlights&width=800&height=1000&seq=mahua-hero-visual&orientation=portrait"
                  alt="麻花影院 - 超清4K影视体验"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50/90 backdrop-blur-md rounded-xl px-4 py-3 shadow-lg border border-background-200/50">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className="ri-movie-2-line text-primary-600 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-foreground-900 font-semibold text-sm whitespace-nowrap">每日更新</div>
                    <div className="text-foreground-500 text-xs">蓝光画质 · 流畅不卡</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}